import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/AgeWage-Icon.svg'
import _imports_1 from '@/assets/AgeWage.svg'


const _hoisted_1 = { class: "logo" }
const _hoisted_2 = {
  key: 0,
  class: "key-stat-illustration"
}
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_openBlock(), _createBlock(_component_v_navigation_drawer, {
    "model-value": _ctx.isVisible,
    "data-testid": "Nav-Drawer",
    app: "",
    clipped: "",
    floating: "",
    class: "drawer dashboard-drawer"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_list, {
        "data-testid": "nav-list",
        variant: "plain"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_v_img, {
              src: _imports_0,
              class: "logo-icon"
            }),
            _createVNode(_component_v_img, {
              src: _imports_1,
              class: "logo-text"
            })
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
            return (_openBlock(), _createBlock(_component_v_list_item, {
              key: item.title,
              ripple: false,
              link: "",
              to: item.route,
              class: "my-3 nav-list-items"
            }, {
              prepend: _withCtx(() => [
                (item.img)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createElementVNode("img", {
                        class: "key-stat-illustration__image",
                        src: item.img
                      }, null, 8, _hoisted_3)
                    ]))
                  : _createCommentVNode("", true),
                (item.icon)
                  ? (_openBlock(), _createBlock(_component_v_icon, {
                      key: 1,
                      small: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.icon), 1)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ]),
              default: _withCtx(() => [
                _cache[0] || (_cache[0] = _createElementVNode("div", { class: "curve-div" }, null, -1)),
                _createVNode(_component_v_list_item_title, { class: "nav-item-text" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.title), 1)
                  ]),
                  _: 2
                }, 1024),
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "curve-div-bottom" }, null, -1))
              ]),
              _: 2
            }, 1032, ["to"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model-value"]))
}